import {useEffect, useRef, useState} from 'react';
import dayjs from 'dayjs';
import Select from 'react-select';
import {Redirect} from 'react-router-dom';

import styles from './styles.module.css';

import http from 'services/http';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import PermissionGate from "../../../utils/PermissionGate";
import {alerta} from "../../../components/Alert";
import ValoresDescarga from './ValoresDescarga';

const MySwal = withReactContent(Swal);

export default function Descarga() {
    const [data, setData] = useState(dayjs().format('YYYY-MM-DD'));
    const [dataBRL, setDataBRL] = useState(dayjs(data).format('DD/MM/YYYY'));
    const [loterias, setLoterias] = useState([]);
    const [loteria, setLoteria] = useState([]);
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const [descarga, setDescarga] = useState([]);
    const [hasNoResultDescarga, setHasNoResultDescarga] = useState(false);
    const [isActiveFildsEditDescarga, setIsActiveFildsEditDescarga] = useState(true);
    const [modalidadesBanca, setModalidadesBanca] = useState([]);
    const [visiblymodalidade, setVisiblyModalidade] = useState(true);

    const [carregaPost, setCarregaPost] = useState(false);
    const [redirectTo, setRedirectTo] = useState(null);

    // Novos estados para premiação e cotação
    const [premiacao, setPremiacao] = useState('');
    const [cotacoes, setCotacoes] = useState([]);
    const [cotacaoSelecionada, setCotacaoSelecionada] = useState('');

    // Função para extrair valores da cotação (M: Milhar, C: Centena, D: Dezena, G: Grupo)
    const extrairValoresCotacao = (nomeCotacao) => {
        if (!nomeCotacao) return { M: 0, C: 0, D: 0, G: 0 };

        const regex = /M:\s*(\d+)\s*\/\s*C:\s*(\d+)\s*\/\s*D:\s*(\d+)\s*\/\s*G:\s*(\d+)/;
        const match = nomeCotacao.match(regex);

        if (match) {
            return {
                M: parseInt(match[1]),
                C: parseInt(match[2]),
                D: parseInt(match[3]),
                G: parseInt(match[4])
            };
        }
        return { M: 0, C: 0, D: 0, G: 0 };
    };

    // Função para buscar cotações
    async function requestCotacoes() {
        try {
            const response = await http.get('bancas/titulo-cotacoes');
            const { data: cotacoesData } = response.data;
            setCotacoes(cotacoesData);
            if (cotacoesData.length > 0) {
                setCotacaoSelecionada(cotacoesData[0].id);
            }
        } catch (error) {
            console.log('Erro ao buscar cotações:', error);
        }
    }

    // Mapeamento de modalidades para tipo de cotação
    const mapearModalidadeParaCotacao = (nomeModalidade) => {
        const nome = nomeModalidade.toLowerCase();

        if (nome.includes('milhar')) return 'M';
        if (nome.includes('centena')) return 'C';
        if (nome.includes('dezena')) return 'D';
        if (nome.includes('grupo')) return 'G';

        return null;
    };

    // Função para calcular os valores da descarga
    function calcularDescarga() {
        if (!premiacao || !cotacaoSelecionada) {
            alerta({ error: true, message: 'Preencha a premiação e selecione uma cotação' });
            return;
        }

        const cotacao = cotacoes.find(c => c.id === parseInt(cotacaoSelecionada));
        if (!cotacao) {
            alerta({ error: true, message: 'Cotação não encontrada' });
            return;
        }

        const valores = extrairValoresCotacao(cotacao.nome);
        const premiacaoNumero = parseFloat(premiacao.replace(',', '.'));

        if (isNaN(premiacaoNumero) || premiacaoNumero <= 0) {
            alerta({ error: true, message: 'Digite um valor válido para premiação' });
            return;
        }

        const arrayModalidades = [...modalidadesBanca];

        arrayModalidades.forEach((modalidade, index) => {
            const tipoCotacao = mapearModalidadeParaCotacao(modalidade.nome);

            if (tipoCotacao && valores[tipoCotacao] > 0) {
                const valorCalculado = premiacaoNumero / valores[tipoCotacao];
                arrayModalidades[index].descarga = (Math.floor(valorCalculado * 100) / 100).toFixed(2).replace('.', ',');
            }
        });

        setModalidadesBanca(arrayModalidades);
        // Libera os inputs para edição após calcular
        setIsActiveFildsEditDescarga(false);
    }

    // Função para formatar valor como moeda (entrada da direita para esquerda)
    const formatarValorMonetario = (valor) => {
        // Remove tudo que não é número
        const apenasNumeros = valor.replace(/\D/g, '');
        // Converte para número e divide por 100 para ter 2 casas decimais
        const numero = parseInt(apenasNumeros || '0', 10) / 100;
        // Formata com 2 casas decimais e usa vírgula como separador
        return numero.toFixed(2).replace('.', ',');
    };

    // Handler para input monetário
    function handleChangeValueDescargaMonetario(event) {
        const targetElement = event.target;
        const index = targetElement.dataset.index;

        // Pega o valor atual e adiciona o novo dígito
        const valorAtual = targetElement.value.replace(/[^0-9]/g, '');
        const novoValor = formatarValorMonetario(valorAtual);

        const arrayModalidades = [...modalidadesBanca];
        arrayModalidades[index].descarga = novoValor;

        setModalidadesBanca(arrayModalidades);
    }

    const naoMostrar = [
        'Milhar Brinde', 'Milhar Moto', 'Unidade',
        'Duque de Grupo', 'Terno de Grupo', 'Duque de Dezena', 'Duque de Dezena F.M.F',
        'Terno de Dezena', 'Terno de Dezena F.M.F', 'Passe', 'Passe vai e vem',
        'Milhar e Centena', 'Milhar Invertida', 'MC Invertida',
        'Centena Invertida'
    ];

    // Ordem de exibição das modalidades
    const ordemModalidades = [
        'Milhar',
        'Centena',
        'Dezena',
        'Grupo',
        'Duque de Dezena 1/2',
        'Duque de Dezena 1/5',
        'Duque de Dezena F.M.F 1/2',
        'Duque de Dezena F.M.F 1/5',
        'Duque de Grupo 1/2',
        'Duque de Grupo 1/5',
        'Terno de Dezena 1/3',
        'Terno de Dezena 1/5',
        'Terno de Dezena 1/10',
        'Terno de Dezena F.M.F 1/3',
        'Terno de Dezena F.M.F 1/5',
        'Terno de Dezena F.M.F 1/10',
        'Terno de Grupo 1/3',
        'Terno de Grupo 1/5',
        'Terno de Grupo 1/10',
        'Passe 1/2',
        'Passe 1/5',
        'Passe vai e vem 1/2',
        'Passe vai e vem 1/5'
    ];

    // Função para verificar se deve mostrar a modalidade (exclui combinados)
    const deveMostrar = (nome) => {
        if (naoMostrar.includes(nome)) return false;
        if (nome.toLowerCase().includes('combinado')) return false;
        return true;
    };

    // Função para ordenar modalidades
    const ordenarModalidades = (modalidades) => {
        return [...modalidades].sort((a, b) => {
            const indexA = ordemModalidades.indexOf(a.nome);
            const indexB = ordemModalidades.indexOf(b.nome);
            // Se não estiver na lista de ordem, coloca no final
            const posA = indexA === -1 ? 999 : indexA;
            const posB = indexB === -1 ? 999 : indexB;
            return posA - posB;
        });
    };

    const containerDescargaLista = useRef();

    // Mapeia o dia da semana para o campo correspondente na loteria
    const mapDiaSemana = {
        0: 'domingo',
        1: 'segunda',
        2: 'terca',
        3: 'quarta',
        4: 'quinta',
        5: 'sexta',
        6: 'sabado'
    };

    const [todasLoterias, setTodasLoterias] = useState([]);

    async function requestLoterias() {
        try {
            const response = await http.get('/loterias', {params: {todas: 1}});

            const loteriasLista = response.data.data.map((loteriaItem) => {
                return {
                    value: loteriaItem.id,
                    label: loteriaItem.nome,
                    ativo: loteriaItem.ativo,
                    domingo: loteriaItem.domingo,
                    segunda: loteriaItem.segunda,
                    terca: loteriaItem.terca,
                    quarta: loteriaItem.quarta,
                    quinta: loteriaItem.quinta,
                    sexta: loteriaItem.sexta,
                    sabado: loteriaItem.sabado,
                };
            });

            setTodasLoterias(loteriasLista.filter(el => el.ativo === true));
        } catch (e) {
            alerta(e.response.data)
        }
    }

    // Filtra loterias pelo dia da semana da data selecionada
    function filtrarLoteriasPorDia(dataSelecionada, loteriasLista) {
        const diaSemana = dayjs(dataSelecionada).day();
        const campoDia = mapDiaSemana[diaSemana];

        const loteriasFiltradas = loteriasLista.filter(el => el[campoDia] === true);

        if (loteriasFiltradas.length > 0) {
            setLoteria(loteriasFiltradas[0]);
        } else {
            setLoteria(null);
        }
        setLoterias(loteriasFiltradas);
    }

    // Função para formatar valor existente (vindo da API) para formato com vírgula
    const formatarValorExistente = (valor) => {
        if (valor === null || valor === undefined || valor === '') return '0,00';
        // Converte para string e substitui ponto por vírgula se necessário
        const valorStr = String(valor).replace(',', '.');
        const numero = parseFloat(valorStr);
        if (isNaN(numero)) return '0,00';
        return numero.toFixed(2).replace('.', ',');
    };

    async function requestModalidadesBanca() {
        try {
            setLoading(true);
            const response = await http.get('/bancas/modalidades');
            const {data: modalidades} = response.data;

            // Formata os valores de descarga para usar vírgula
            const modalidadesFormatadas = modalidades.map((mod) => ({
                ...mod,
                descarga: formatarValorExistente(mod.descarga)
            }));

            setModalidadesBanca(modalidadesFormatadas);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            alerta(error.response.data)
        }
    }

    useEffect(() => {
        http.get('/bancas/minha-banca')
            .then(res => {
                const banca = res.data.data;
                if (banca?.descarga_banca_id || banca?.is_descarga_destino) {
                    setRedirectTo('/descarga-automatica');
                }
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        requestLoterias();
        requestModalidadesBanca();
        requestCotacoes();
    }, []);

    // Filtra loterias quando a data mudar ou quando carregar as loterias
    useEffect(() => {
        if (todasLoterias.length > 0) {
            filtrarLoteriasPorDia(data, todasLoterias);
        }
    }, [data, todasLoterias]);

    useEffect(() => {
        setDataBRL(dayjs(data).format('DD/MM/YYYY'));
    }, [data]);

    async function buscarDescarga() {
        try {
            setLoading(true);
            setVisiblyModalidade(false);

            const response = await http.get('/descargas', {
                params: {
                    loteria: loteria.value,
                    data: data,
                },
            });

            const {descarga, total} = response.data;
            setDescarga(descarga);
            setTotal(total);
            setLoading(false);

            if (descarga.length === 0) {
                setHasNoResultDescarga(true);
            } else {
                setHasNoResultDescarga(false);
            }
        } catch (e) {
            alerta(e.response.data)
        }
    }

    function downloadPdf(blob, nome) {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nome);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    async function enviarPdf() {
        try {
            setLoading(true);

            const response = await http({
                url: '/descargas/baixar',
                method: 'GET',
                responseType: 'blob',
                params: {
                    loteria: loteria.value,
                    data: data,
                },
            });

            const nome = `descarga-${loteria.label}-${data}.pdf`;
            const file = new File([response.data], nome, { type: 'application/pdf' });

            // Tenta compartilhar via Web Share API
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({
                        files: [file],
                        title: `Descarga - ${loteria.label}`,
                        text: `Descarga do dia ${dataBRL}`,
                    });
                } catch (shareError) {
                    // Se o usuário cancelou, não faz nada; se falhou (ex: arquivo grande), baixa
                    if (shareError.name !== 'AbortError') {
                        downloadPdf(response.data, nome);
                    }
                }
            } else {
                downloadPdf(response.data, nome);
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }

    function handleClickEditDescarga(event) {
        event.preventDefault();
        setIsActiveFildsEditDescarga(
            (isActiveFildsEditDescarga) => !isActiveFildsEditDescarga,
        );
    }

    async function salvarDescarga() {
        try {
            setCarregaPost(true);

            const res = await http.patch('/bancas/modalidades', {
                modalidades: modalidadesBanca,
            });

            alerta(res.data)
            setCarregaPost(false);

        } catch (e) {
            alerta(e.response.data)
            setCarregaPost(false);
        }
    }

    if (redirectTo) {
        return <Redirect to={redirectTo} />;
    }

    return (
        <>
            <div className='titulo-principal'>Descarga</div>

            <div className='d-flex tres-colunas conteudo-principal'>
                <input
                    required
                    type='date'
                    onChange={(event) => {
                        setData(event.target.value);
                        setHasNoResultDescarga(false);
                    }}
                    className='form-control'
                    value={data}
                />

                <Select
                    label='Single select'
                    placeholder='Extração'
                    options={loterias}
                    value={loterias.filter(({value}) => value === loteria.value)}
                    onChange={(event) => {
                        setLoteria(event);
                        setHasNoResultDescarga(false);
                    }}
                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                    })
                    }
                />


                <button
                    style={{height: '38px'}}
                    type='submit'
                    className='btn btn-primary' onClick={buscarDescarga}>
                    Buscar
                </button>

                <button
                    className={`btn btn-success ${styles.buttonSalvarPDF}`} onClick={enviarPdf}>
                    Enviar PDF
                </button>
            </div>

            {loading && <div className='loader'/>}

            {!loading && descarga.length > 0 && (
                <>
                    <div className={styles.containerTitle}>
                        <div
                            style={{marginTop: '13px'}}
                            className='d-flex duas-colunas '
                        >
                            <div className={styles.title}>
                                <h4>{loteria.label}</h4>
                            </div>
                            <div>
                                <h4>{dataBRL}</h4>
                            </div>
                        </div>


                        <table className='table m-t '>
                            <thead>
                            <tr>
                                <th>Modalidade</th>
                                <th>Palpite</th>
                                <th>Sorteio</th>
                                <th>Valor</th>
                            </tr>
                            </thead>
                            <tbody>
                            {descarga.map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td>{item.modalidade.replace(/duque\s*de\s*grupo\s*combinado/gi, "Grupo Combinado")}</td>
                                        <td>{item.numero}</td>
                                        <td>{item.sorteio}</td>
                                        <td>R$ {item.valor}</td>
                                    </tr>
                                );
                            })}
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan='3'>
                                    <b>Total:</b>
                                </td>
                                <td>
                                    <b>R$ {total}</b>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </>
            )}

            {hasNoResultDescarga && (
                <div className={styles.noResult}>
                    <p>
                        Nenhum descarga na loteria <b>{loteria.label}</b> para o dia{' '}
                        <b>{dataBRL}</b>
                    </p>
                </div>
            )}

            {visiblymodalidade && <ValoresDescarga />}

        </>
    );
}
